module.exports = __webpack_public_path__ + "media/images/icon-filter-26c8f8adec04216dc40a899e16c608b9.svg";